// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class OrderLineStatus extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  static OrderLineStatusOptions = {
        InProcess: 1,
        Built: 2,
        Stacked: 3,
        Complete: 4,
        ReadToDeliverPickup: 6,
        WaitingOn: 8,
        DeliveredPickedUp: 9,
        New: 10,
        Winter: 11,
        PackSlipCreated: 12,
    };
  /// </code>

  // Generated code. Do not place code below this line.
  id!: number;
  countAsWIP!: boolean;
  displayOrder?: number;
  name?: string;
}

